module.exports = __webpack_public_path__ + "assets/icon4.61a19568.svg";